import amplitude from "amplitude-js";
import { GeneralTypes } from "@/types";

const useAnalyticsAPIProduction = site.useAnalyticsAPIEnv === "prod"; // this controls whether or not data goes to the 'real' chart

const useAnalyticsAPIStaging = true && site.useAnalyticsAPIEnv === "staging"; // data goes to test chart. should be true usually, unless you specifically DONT want logging from staging

const useAnalyticsAPIDevelopment = false && site.useAnalyticsAPIEnv === "development"; // data goes to test chart. Shold be false when submitting a PR. devs can toggle via changing true/false.

const amplitudeClient = amplitude.getInstance();
amplitudeClient.init(site["analyticsAPIKey"]);

export const setAnalyticsUserId = (id: string): void => {
  useAnalyticsAPIProduction ? amplitudeClient.setUserId(id) : amplitudeClient.setUserId("TEST_USER");
};

export const logEvent = async (eventName: string, params?: GeneralTypes.Dictionary): Promise<void> => {
  if (
    useAnalyticsAPIProduction // always log in prod
    || useAnalyticsAPIStaging // log in staging if opted in
    || useAnalyticsAPIDevelopment // log in dev if opted in
  ) {
    amplitudeClient.logEvent(eventName, { ...params });
  }
};

export const ANALYTIC_EVENTS = {
  MAIN_MENU: {
    hamburgerOpen: "hamburger open",
    hamburgerClose: "hamburger close",
    breadcrumb: "breadcrumb",
  },
};
